// Jedino mjesto koje nabraja jezike aplikacije na frontendu — mora se
// podudarati s backendovim SupportedLanguages.CODES i s `supportedLngs` u
// src/i18n/index.ts. Redoslijed ovdje određuje i redoslijed NAZIV polja na
// admin formi za jedinice (Figma: EN, DE, HR).
export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'EN' },
  { code: 'de', label: 'DE' },
  { code: 'hr', label: 'HR' }
];
